import { axiosInstance } from "@hopper-b2b/api";
import { getLang } from "@hopper-b2b/i18n";
import { getAcceptLanguagesFromLocale } from "@hopper-b2b/utilities";

export interface HeaderFooterResponse {
  header: string;
  footer: string;
}
export const headerFooterGet = async () => {
  const END_POINT = `/api/v0/headerFooter`;
  try {
    const locale = getLang();
    const response = await axiosInstance.get(END_POINT, {
      headers: {
        "Accept-Language": getAcceptLanguagesFromLocale(locale).join(","),
      },
    });
    return response.data;
  } catch (error) {
    console.error("fetch header footer error:", error);
    throw Error("fetch header footer error");
  }
};

export const fetchHeaderFooter = (): Promise<HeaderFooterResponse> => {
  return headerFooterGet();
};

export default fetchHeaderFooter;
